import { render, staticRenderFns } from "./dealResult.vue?vue&type=template&id=e2d08ec4"
import script from "./dealResult.vue?vue&type=script&lang=js"
export * from "./dealResult.vue?vue&type=script&lang=js"
import style0 from "./dealResult.vue?vue&type=style&index=0&id=e2d08ec4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports